/**
 * Fields allowed in an advanced search form
 */
export enum ProductSearchField {
    Active = "active",
    Brand = "brand",
    Category = "category",
    Container = "container",
    Count = "count",
    Country = "countries",
    Description = "description",
    // Shows localizations and languages
    Localizations = "localizations",
    Manufacturer = "manufacturer",
    Name = "name",
    Query = "query",
    SearchLanguage = "searchLanguage",
    // Shows size and uom
    Size = "size",
    Temporary = "temporary"
}
